import { jsxs as A, jsx as f } from "react/jsx-runtime";
import { clsx as m } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as z, useRef as a } from "react";
import { getRovingIndex as _ } from "../../utils/roving-index.js";
import { scrollElementIntoViewVertically as M } from "../../utils/scroll-element-into-view-vertically.js";
import { useHorizontalScrollIntoView as q } from "../../utils/use-horizontal-scroll-into-view.js";
import { useIsDocumentRTL as F } from "../../utils/use-rtl-direction.js";
import { useScrollActiveItemIntoViewOnMount as G } from "../../utils/use-scroll-active-item-into-view-on-mount.js";
import { useScrollBlur as J } from "../../utils/use-scroll-blur.js";
import { RocheUIIcon as D } from "../icon/roche-icon.js";
import n from "./roche-tabs.module.scss.js";
const P = (u, l) => l === void 0 || l < 0 || l >= ((u == null ? void 0 : u.length) ?? 0) ? 0 : l, ie = ({
  initiallySelected: u,
  appearance: l = "default",
  autoScroll: L = !0,
  centered: b = !1,
  hasMarginTop: E = !0,
  tabs: e,
  children: v,
  slot: S,
  onTabClick: R,
  activeTabId: w,
  scrollActiveTabIntoViewOnMount: H = !1,
  scrollPageToActiveTabOnMount: W = !1
}) => {
  const g = F(), y = w !== void 0, [j, C] = z(
    () => P(e, u)
  ), N = (e == null ? void 0 : e.findIndex((r) => r.id === w)) ?? -1, c = y && N >= 0 ? N : j, h = a([]), T = a(null), I = a(null), V = a(null), k = a(null), p = J(I), { scrollIntoView: x } = q(h, I, {
    leftInsetRef: V,
    rightInsetRef: k
  });
  G(H && L, () => {
    if (x(c), W) {
      const r = h.current[c];
      r && M(r);
    }
  });
  const K = (r) => {
    y || C(r);
  }, O = (r) => {
    const t = (e == null ? void 0 : e.findIndex((d) => d.id === r.currentTarget.id)) ?? null;
    if (t === null || t < 0)
      return;
    const o = e == null ? void 0 : e[t], i = (o == null ? void 0 : o.headline) || "", s = (o == null ? void 0 : o.id) || "";
    R == null || R(r, i, s), t !== c && (K(t), x(t));
  }, U = (r) => {
    var d;
    if (!e || e.length === 0 || !r.key)
      return;
    const { key: t } = r, o = () => h.current.indexOf(document.activeElement), i = {
      ArrowRight: () => _(g ? "previous" : "next", o(), e.length),
      ArrowLeft: () => _(g ? "next" : "previous", o(), e.length),
      Home: () => _("first", o(), e.length),
      End: () => _("last", o(), e.length)
    };
    if (!i[t])
      return;
    r.preventDefault();
    const s = i[t]();
    s !== o() && ((d = h.current[s]) == null || d.focus(), x(s));
  }, B = (r) => {
    const t = T.current, o = I.current;
    if (!o || !t || Array.from(o.children).length === 0)
      return;
    const s = ((t == null ? void 0 : t.offsetWidth) ?? 0) * 0.8, d = r === "right" ? s : -s;
    o.scrollBy({
      left: d,
      behavior: "smooth"
    });
  }, $ = m(n.tabs, {
    [n["tabs--centered"]]: b,
    [n["tabs--no-margin"]]: !E,
    [n["tabs--filter"]]: l === "filter" || l === "filter-grey",
    [n["tabs--filter-grey"]]: l === "filter-grey",
    [n["tabs--light"]]: l === "light"
  });
  return /* @__PURE__ */ A("div", { className: $, slot: S, children: [
    /* @__PURE__ */ A("div", { className: n["tabs__tab-list-wrapper"], ref: T, children: [
      (p === "left" || p === "both") && /* @__PURE__ */ f(
        "div",
        {
          className: m(n["tabs__scroll-button"], n["tabs__scroll-button--left"]),
          onClick: () => B("left"),
          ref: V,
          children: /* @__PURE__ */ f(D, { icon: g ? "chevron-right" : "chevron-left", height: "24px" })
        }
      ),
      /* @__PURE__ */ f("div", { className: n["tabs__tab-list"], role: "tablist", ref: I, children: e == null ? void 0 : e.map((r, t) => /* @__PURE__ */ f(
        "button",
        {
          className: m(n.tabs__tab, c === t && n["tabs__tab--active"]),
          id: r.id,
          type: "button",
          role: "tab",
          "aria-selected": c === t,
          "aria-controls": `panel-${r.id}`,
          tabIndex: c === t ? 0 : -1,
          onClick: O,
          onKeyDown: U,
          ref: (o) => {
            h.current[t] = o;
          },
          children: /* @__PURE__ */ f("span", { className: n["tabs__tab-label"], children: r.headline })
        },
        r.id
      )) }),
      (p === "right" || p === "both") && /* @__PURE__ */ f(
        "div",
        {
          className: m(n["tabs__scroll-button"], n["tabs__scroll-button--right"]),
          onClick: () => B("right"),
          ref: k,
          children: /* @__PURE__ */ f(D, { icon: g ? "chevron-left" : "chevron-right", height: "24px" })
        }
      )
    ] }),
    v == null ? void 0 : v.map((r, t) => {
      var o, i;
      return /* @__PURE__ */ f(
        "div",
        {
          className: m(n.tabs__panel, c === t && n["tabs__panel--active"]),
          id: `panel-${(o = e == null ? void 0 : e[t]) == null ? void 0 : o.id}`,
          role: "tabpanel",
          "aria-labelledby": (i = e == null ? void 0 : e[t]) == null ? void 0 : i.id,
          hidden: c !== t,
          children: r
        },
        t
      );
    })
  ] });
};
export {
  ie as RocheUITabs
};
